import { correspondeChave } from '@/utils/produtoOperacoes'
import { lerPreferenciasProdutos } from '@/services/produtosFrontendService'

export async function localizarProdutoChave(vm, termo, lista = []) {
  const companyId = vm.$store.state.empresa?.id
  const chave = lerPreferenciasProdutos(companyId).chave || 'TODAS'
  const unicos = dados => [...new Map(dados.filter(p => correspondeChave(p, termo, chave)).map(p => [String(p.id), p])).values()]
  const locais = unicos(lista)
  if (locais.length > 1) throw new Error('Chave ambígua. Use Ctrl+Enter para selecionar o produto.')
  if (locais.length === 1) return locais[0]
  const campos = chave === 'BARRAS' ? ['codigoBarra'] : chave === 'INTERNO' ? ['id'] : chave === 'SKU' ? ['sku'] : ['codigoBarra', 'id', 'sku']
  const resultados = await Promise.allSettled(campos.filter(c => c !== 'id' || /^\d+$/.test(termo)).map(c => vm.$axios.get(vm.$store.state.urlRest + 'product', { headers: { 'X-Company-Id': companyId }, params: { [c]: termo, page: 0, size: 100, ativo: true, exibirItensGrade: true } })))
  if (resultados.every(r => r.status === 'rejected')) throw new Error('Não foi possível consultar a chave do produto.')
  const produtos = unicos(resultados.filter(r => r.status === 'fulfilled').flatMap(r => Array.isArray(r.value.data) ? r.value.data : r.value.data.content || []))
  if (produtos.length > 1) throw new Error('Chave ambígua. Use Ctrl+Enter para selecionar o produto.')
  return produtos[0] || null
}
export default {
  inserted(el, binding, vnode) {
    let ocupado = false
    let navegacaoLista = false
    el._produtoChave = async event => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { navegacaoLista = true; return }
      if (event.key.length === 1 || event.key === 'Backspace' || event.key === 'Delete') navegacaoLista = false
      if (event.key !== 'Enter' || event.ctrlKey || event.altKey || event.metaKey) return
      if (navegacaoLista) { navegacaoLista = false; return }
      const select = vnode.componentInstance
      const termo = String(select?.search || '').trim()
      if (!termo || select.disabled) return
      event.preventDefault(); event.stopImmediatePropagation()
      if (ocupado) return
      ocupado = true
      const vm = vnode.context
      const empresa = vm.$store.state.empresa?.id
      try {
        const produto = await localizarProdutoChave(vm, termo, select.options || [])
        if (empresa !== vm.$store.state.empresa?.id || !el.isConnected) return
        if (!produto) { vm.$toast.fire({ icon: 'info', title: 'Chave não encontrada. Use Ctrl+Enter para pesquisar por descrição.' }); return }
        const normalizado = typeof vm.normalizarProduto === 'function' ? vm.normalizarProduto(produto) : produto
        const option = { ...produto, ...normalizado, nomeExibicao: normalizado.nomeExibicao || produto.descricao }
        // Os handlers das rotinas resolvem o produto na lista antes de preencher preço/unidade.
        const lista = select.options
        if (Array.isArray(lista) && !lista.some(p => String(p.id) === String(option.id))) lista.push(option)
        if (Array.isArray(vm.produtos) && !vm.produtos.some(p => String(p.id) === String(option.id))) vm.produtos.push(option)
        select.select(option)
        select.search = ''; select.open = false
      } catch (e) { vm.$toast.fire({ icon: 'warning', title: e.message }) } finally { ocupado = false }
    }
    el.addEventListener('keydown', el._produtoChave, true)
  },
  unbind(el) { el.removeEventListener('keydown', el._produtoChave, true); delete el._produtoChave }
}
